<template>
  <div id="app">
  
    <router-view/>
  </div>
</template>

<script>
  import UIkit from 'uikit';
  import Icons from 'uikit/dist/js/uikit-icons';
  UIkit.use(Icons);
  export default {
      name: 'App',
  };
</script>


<style lang="less">
@import "../node_modules/uikit/src/less/uikit.less";

#app, body {
  font-family: 'News Cycle', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
